// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__1_ve0","content":"style_content__36aUT"};